import "./App.css";
import { Layout } from "antd";

import Content from "./components/Content";
import FooterComponent from "./components/Footer/footer";
import HeaderComponent from "./components/Header/header";

function App() {
  return (
    <Layout>
      <HeaderComponent />
      <Content />
      <FooterComponent />
    </Layout>
  );
}

export default App;
